export const products = [
  {
    id: 1,
    imageUrl:
      'https://cdn.pixabay.com/photo/2023/10/07/14/24/smartwatch-8300238_1280.jpg',
    name: 'Smart Watch',
    category: 'Watches',
    producer: 'Rolex',
    status: 'In Stock',
    declaredBy: 'Rolex Times',
    date: '2025-10-01',
    evidenceCount: 4,
    versions: [
      {version: '2.0', date: '2025-05-15'},
      {version: '2.1', date: '2025-09-16'},
    ],
  },
  {
    id: 2,
    imageUrl:
      'https://cdn.pixabay.com/photo/2017/08/06/02/49/headphones-2588056_1280.jpg',
    name: 'Noise Cancelling Headphones',
    category: 'Audio',
    producer: 'Sony',
    status: 'Out of Stock',
    declaredBy: 'Sony Audio',
    evidenceCount: 7,
    date: '2025-10-01',
    versions: [
      {version: '1.4', date: '2024-11-02'},
      {version: '1.5', date: '2025-06-18'},
    ],
  },
  {
    id: 3,
    imageUrl:
      'https://cdn.pixabay.com/photo/2014/12/10/12/26/iphone-563067_1280.jpg',
    name: 'iPhone 17 Pro',
    category: 'Phones',
    producer: 'Apple',
    date: '2025-10-01',
    status: 'Limited Stock',
    declaredBy: 'Apple Labs',
    evidenceCount: 12,
    versions: [
      {version: '3.0', date: '2025-03-10'},
      {version: '3.1', date: '2025-12-01'},
    ],
  },
  {
    id: 4,
    imageUrl:
      'https://cdn.pixabay.com/photo/2022/07/14/04/58/camera-7320445_1280.jpg',
    name: 'DSLR Camera',
    category: 'Cameras',
    producer: 'Canon',
    status: 'Out of Stock',
    declaredBy: 'Canon Imaging',
    evidenceCount: 5,
    date: '2025-10-01',
    versions: [
      {version: '5.2', date: '2024-08-20'},
      {version: '5.3', date: '2025-02-14'},
    ],
  },
  {
    id: 5,
    imageUrl:
      'https://cdn.pixabay.com/photo/2017/08/10/08/47/laptop-2620118_1280.jpg',
    name: 'Dell 15',
    category: 'Laptops',
    producer: 'Dell',
    status: 'In Stock',
    declaredBy: 'Dell Tech',
    evidenceCount: 9,
    date: '2025-10-01',
    versions: [
      {version: '6.0', date: '2025-01-05'},
      {version: '6.1', date: '2025-10-12'},
    ],
  },
  {
    id: 6,
    imageUrl:
      'https://cdn.pixabay.com/photo/2022/05/16/11/45/watch-7200156_1280.jpg',
    name: 'Quartz Watch',
    category: 'Watches',
    producer: 'Quartz Classic',
    date: '2025-10-01',
    status: 'In Stock',
    declaredBy: 'Quartz Heritage',
    evidenceCount: 3,
    versions: [
      {version: '1.0', date: '2025-02-12'},
      {version: '1.1', date: '2025-09-07'},
    ],
  },
  {
    id: 7,
    imageUrl:
      'https://cdn.pixabay.com/photo/2020/10/03/15/33/ear-phones-5623843_1280.jpg',
    name: '1+ Ear Buds',
    category: 'Audio',
    producer: 'OnePlus',
    status: 'Limited Stock',
    declaredBy: 'OnePlus Acoustic',
    evidenceCount: 8,
    date: '2025-10-01',
    versions: [
      {version: '2.2', date: '2024-10-20'},
      {version: '2.3', date: '2025-07-30'},
    ],
  },
  {
    id: 8,
    imageUrl:
      'https://cdn.pixabay.com/photo/2016/03/27/19/36/samsung-galaxt-note-edge-1283897_1280.jpg',
    name: 'Samsung Galaxy S15',
    category: 'Phones',
    producer: 'Samsung',
    status: 'Limited Stock',
    declaredBy: 'Samsung Devices',
    date: '2025-10-01',
    evidenceCount: 10,
    versions: [
      {version: '5.0', date: '2025-03-01'},
      {version: '5.1', date: '2025-11-11'},
    ],
  },
  {
    id: 9,
    imageUrl:
      'https://cdn.pixabay.com/photo/2018/10/16/21/12/slr-camera-3752509_1280.jpg',
    name: 'Mirrorless Camera',
    category: 'Cameras',
    producer: 'Nikon',
    status: 'Out of Stock',
    declaredBy: 'Nikon Imaging',
    evidenceCount: 4,
    date: '2025-10-01',
    versions: [
      {version: '3.6', date: '2024-12-15'},
      {version: '3.7', date: '2025-06-09'},
    ],
  },
]
export default products
